import { Alert, Button } from '@mui/material';
import { FallbackProps } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import Layout from '../Layout';

export default function EndSessionDialogErrorFallback(props: FallbackProps & { sessionId: string | null, onClose: () => void }) {
  const {
    error,
    resetErrorBoundary,
    sessionId,
    onClose,
  } = props;
  const { t } = useTranslation();

  return (
    <Layout sessionId={sessionId} onClose={onClose}>
      <Alert severity="error" action={<Button onClick={resetErrorBoundary}>{t('error.reload-page')}</Button>}>
        {t('error.text')}
        {' '}
        {error.message}
      </Alert>
    </Layout>
  );
}
